import { Component, OnInit, AfterViewInit } from '@angular/core';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { PreloaderService } from '@shared/services/preloader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, AfterViewInit {
  isIframe:boolean = false;

  constructor(private preloader: PreloaderService, public router: Router) {}

  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;
    //redirect to https for non-development modes
    if (environment.build != "Development" && environment.enableHttpsRedirect) {
      if (location.protocol === 'http:') {
        window.location.href = location.href.replace('http', 'https');
      }
    }
  }

  ngAfterViewInit() {
    this.preloader.hide();
  }
}